import { UTCDate } from '@date-fns/utc';
import { useState } from 'react';
import { Inline } from '../../../../design-system/inline/inline';
import { Select } from '../../../../design-system/select/select';
import { Stack } from '../../../../design-system/stack/stack';
import { AccountView } from '../../../../types/entity-types';
import { SupportedCountryCurrency } from '../../../../types/supported-country-currency';
import { CurrentCashChart } from '../../components/charts/current-cash-chart';
import { getHistoricalBalanceSeries, HistoricalBalanceSeriesFilter } from '../../utils/get-historical-balance-series';
import { getHistoricalCashBalance } from '../../utils/get-historical-cash-balance';

type CurrentCashWrapperProps = {
  accounts: AccountView[];
  baseCurrency: SupportedCountryCurrency;
};

export const CurrentCashWrapper = ({ accounts, baseCurrency }: CurrentCashWrapperProps) => {
  const [filter, setFilter] = useState<HistoricalBalanceSeriesFilter>('three_months');
  const data = getHistoricalBalanceSeries({
    accounts,
    baseCurrency,
    filter,
  });

  const currentCashData = getHistoricalCashBalance({
    accounts,
    baseCurrency,
    targetDate: new UTCDate(),
  });

  return (
    <Stack className="w-full" space={4}>
      <h2 className="text-xl font-medium">Cash Flow</h2>
      <div className="w-full rounded-[10px] border-[0.5px] border-seapoint-gray-border pb-4 pt-4">
        <Inline className="px-8 pb-5" justify="between">
          <Stack space={2}>
            <p className="text-xs font-normal text-seapoint-gray-text">Current Cash</p>
            <p className="text-xl font-medium">{currentCashData.formattedHistoricalBalance}</p>
          </Stack>
          <div className="mt-1">
            <Select
              placeholder="Select Timeframe"
              value={filter}
              onValueChange={(value) => setFilter(value as HistoricalBalanceSeriesFilter)}
            >
              <Select.Item value="week">Past Week</Select.Item>
              <Select.Item value="month">Last 30 Days</Select.Item>
              <Select.Item value="three_months">Past Three Months</Select.Item>
              <Select.Item value="six_months">Past Six Months</Select.Item>
              <Select.Item value="year">Past Year</Select.Item>
            </Select>
          </div>
        </Inline>
        <CurrentCashChart data={data} baseCurrency={baseCurrency} height={200} />
      </div>
    </Stack>
  );
};
